import * as React from "react";

const PanelArrowRight = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <path fill="#444F5C" d="M16 9.875L6 16.75V3z" fillRule="evenodd" />
  </svg>
);

export default PanelArrowRight;

